// Copyright (c) 2019 Comsearch, Inc., All rights reserved

const customEmissionDesignatorValue = v => {
  const emissionDesignatorRegex = /^([0-9ABCDEFGHJKLMNPQRTVWX]{7,9}|[0-9ABCDEFGHJKLMNPQRTVWX]{3,5})$/i
  return (
    !v.match(emissionDesignatorRegex) && 'Alphanumeric characters except I, O, S, U, Y, Z of length between 3-5 or 7-9.'
  )
}

export default customEmissionDesignatorValue
